import React, { useEffect } from 'react';

import {
  SummaryHeaderWrapper,
  SummaryPageHeader,
  SummaryWrapper
} from 'components/SummaryComponents';

import { ROOT_PATH } from 'constants/routeConstants';

import { useHistory } from 'react-router-dom';

import { env } from 'api/api';

export function Sandbox() {
  const history = useHistory();

  useEffect(() => {
    if (env !== 'local') {
      history.push(ROOT_PATH);
    }
  }, []);

  return (
    <SummaryWrapper>
      <SummaryHeaderWrapper>
        <SummaryPageHeader title="Sandbox" />
      </SummaryHeaderWrapper>
    </SummaryWrapper>
  );
}
